import { z } from "zod";
const attributesCodeBlockSchema = z.object({
  lang: z.string(),
  title: z.string().optional(),
  maxHeight: z.string().optional(),
  minHeight: z.string().optional(),
  lineNumbers: z.coerce.boolean().optional().default(false),
  lineNumberStart: z.coerce.number().optional().default(0),
  highlight: z.string().optional().default(""),
  focus: z.string().optional().default(""),
  added: z.string().optional().default(""),
  removed: z.string().optional().default(""),
  fullHeight: z.coerce.boolean().optional().default(false)
});
export {
  attributesCodeBlockSchema
};
//# sourceMappingURL=attributes.js.map
